import { commonAction } from '../types/commonActions';
import { baseContextType, createContext } from './createContext';
import { FC, useContext } from 'react';
import { AppProps } from 'next/app';

export type profileType = {
  contacts: any;
  name: string;
  image?: string;
  primary_mobile_number: string;
  hashed_mobile_number: string;
  customer_code: string;
  isLoggedIn?: boolean;
  webEngageId?: string;
  customerId?: string;
  firstName: string;
  lastName: string;
  scCode?: string;
  phoneNumber?: string;
};

export type profileDispatchType = {
  updateNameTo: Function;
  loadProfile: Function;
};

const actionNames = {
  updateName: 'updateName',
  loadProfile: 'loadProfile',
};

const profileData = {
  name: '',
  image: '',
  primary_mobile_number: '',
  hashed_mobile_number: '',
  customer_code: '',
  isLoggedIn: false,
  webEngageId: '',
  contacts: [],
  firstName: '',
  lastName: '',
  scCode: '',
};

const reducer = (state: profileType, action: commonAction): profileType => {
  switch (action.type) {
    case actionNames.updateName:
      return { ...state, name: action.payload };
    case actionNames.loadProfile:
      return { ...state, ...action.payload };
    // istanbul ignore next
    default:
      return state;
  }
};

const updateNameTo = (dispatch: any) => (name: string) =>
  dispatch({ type: actionNames.updateName, payload: name });

const loadProfile = (dispatch: any) => (profile: profileType) =>
  dispatch({ type: actionNames.loadProfile, payload: profile });

const { Context: ProfileContext, Provider: ProfileProvider } = createContext<
  profileType,
  profileDispatchType
>(reducer, { updateNameTo, loadProfile }, profileData);

ProfileContext.displayName = 'Profile';
export { ProfileContext, ProfileProvider };

interface HigherOrderComponentProps {
  profileContext: baseContextType<profileType, profileDispatchType>;
}

export const withProfile = (Component: FC<HigherOrderComponentProps>) => {
  return function contextComponent(props: AppProps) {
    return (
      <ProfileContext.Consumer>
        {(context) => <Component {...props} profileContext={context} />}
      </ProfileContext.Consumer>
    );
  };
};

export const useProfileContext = () => useContext(ProfileContext);
